import UiService from "../../core/helpers/ui-service.helper";
import {ConfirmationViewModel} from "./confirmation.vm";

export const ConfirmationInitialiser = () => {
  ko.applyBindings(new ConfirmationViewModel(), document.body);

  $(() => {
    UiService.ApplyContainerMinHeight();
  });  
}